import dynamic from 'next/dynamic';
import { useRouter } from "next/router";
import BreadCrumbs from "../../src/components/BreadCrumbs";
import { GameList, findGame, similarGames } from "../../src/lib/gameData";
import { Assets } from "../../src/list/Assets";
import { organization } from "../../src/list/Schema_Detail";
import { useEffect, useState, useRef } from "react";
import { gameFacts, startContent, stopContent } from "../../src/lib/behavior";
import {Categories }from "../../src/list/PageList";
import GridLayout from '../../src/components/GridLayout.js';
import CategoryGames from '../../src/components/CategoryGames.js';
// Schema
import Breadcrumb from "../../src/schema/Breadcrumb";
import FAQPage from "../../src/schema/FAQPage";

import Headcom from '../../src/components/Headcom.js';
import Ad_320x50 from '../../src/ads/Ad_320x50.js';

const FooterCom = dynamic(() => import('../../src/components/FooterCom'));
const FooterDis = dynamic(() => import('../../src/Description/FooterDis'));

const Snow_fx = dynamic(() => import('../../src/fx/Snow_fx'));
const CommenDis = dynamic(() => import('../../src/Description/CommenDis'));

const CatBtn = dynamic(() => import('../../src/components/CatBtn'));
const BlackScreen = dynamic(() => import('../../src/components/BlackScreen'));
const CookieCom = dynamic(() => import('../../src/components/CookieCom'));

const MobileExitButton = dynamic(() => import('../../src/components/MobileExitButton.js'));
// Records the play and shows "Because you played ..." (browser only, reads localStorage)
const PersonalRows = dynamic(() => import('../../src/components/PersonalRows'), { ssr: false });

const Ad_300x250_1 = dynamic(() => import('../../src/ads/Ad_300x250_1'), {
  ssr: false,
  loading: () => <p>Loading Ad...</p>,
});

const Ad_728x90_Bot = dynamic(() => import('../../src/ads/Ad_728x90_Bot'), {
  ssr: false,
  loading: () => <p>Loading Ad...</p>,
});

export async function getStaticPaths() {
  return {
    paths: GameList.map((page) => ({
      params: { id: page.name[1] },
    })),
    fallback: false,
  };
}

export async function getStaticProps({ params }) {
  return {
    props: {
      game: findGame(params.id), // only load this game’s data
      moreGames: similarGames(params.id, 50), // "Because you played …" thumbnails under the game
    },
  };
}

// export async function getStaticProps({ params }) {
//   return {
//     props: {
//       GameList,
//     },
//   };
// }

export default function GameId({ game, moreGames }) {
  const viewMoreUrls = {};
  for (let i = 1; i <= 2; i++) {
    viewMoreUrls[`Category ${i}`] = `/category-${i}`;
  }
  
  const path = useRouter();
  const pathName = path.query.id;
  const [isSmall, setSmall] = useState(false);
  const [mobile, setMobile] = useState(false);
  const mobileBlackScreen = useRef(null);
  const gamePage = useRef(null);
  const mobileView = useRef(null);
  const mobileIframe = useRef(null);
  const mobileMenu = useRef(null);
  const mobileCanvas = useRef(null);
  var catlink;
  var catname;

  catlink =BreadCatLink(game.tag);
  catname =BreadcatName(game.tag);

  // GA4: this game was opened, and how long it holds the player (src/lib/behavior.js)
  const gameSlug = game.path[0].split("/").pop();
  useEffect(() => {
    startContent({ type: "game", item: gameSlug, ...gameFacts(game) });
    return stopContent;
  }, [gameSlug]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (typeof window !== "undefined") {
      // Set the default body style
      document.body.style.overflow = "auto";

      const handleResize = () => {
        if (
          window.innerWidth >= 747 &&
          !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          )
        ) {
          setSmall(false);
        } else {
          setSmall(true);
        }
        if (
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          )
        ) {
          setMobile(true);
        } else {
          setMobile(false);
        }
      };

      const handleFullscreenChange = () => {
        if (!document.fullscreenElement) {
          // Fullscreen mode has been exited
          mobileExitYes();
        }
      };

      // Add window and document event listeners
      window.addEventListener("resize", handleResize);
      document.addEventListener("fullscreenchange", handleFullscreenChange);
      document.addEventListener("webkitfullscreenchange", handleFullscreenChange); // For Safari
      document.addEventListener("mozfullscreenchange", handleFullscreenChange); // For Firefox
      document.addEventListener("MSFullscreenChange", handleFullscreenChange); // For IE/Edge

      // Handle initial resize
      handleResize();


      // Clean up event listeners on component unmount
      return () => {
        window.removeEventListener("resize", handleResize);
        document.removeEventListener("fullscreenchange", handleFullscreenChange);
        document.removeEventListener("webkitfullscreenchange", handleFullscreenChange);
        document.removeEventListener("mozfullscreenchange", handleFullscreenChange);
        document.removeEventListener("MSFullscreenChange", handleFullscreenChange);

      };
    }
  }, [mobileExitYes]);


  function Sandbox(value) {
    var sand_value;
    if (value == "cutedressup" || value == "playcutegames"|| value == "Y8"|| value == "VI"|| value == "bestgamespot") {
      // sand_value = "allow-scripts allow-popups allow-same-origin";
    } else {
      // sand_value =
        // "allow-forms allow-pointer-lock allow-popups-to-escape-sandbox allow-same-origin allow-scripts allow-top-navigation-by-user-activation";
    }
    return sand_value;
  }

  function mPlaybtn() {
    gamePage.current.setAttribute("style", "display:none");
    mobileView.current.setAttribute("style", "display:flex");
    mobileIframe.current.src = game.iframe;
    // mobileIframe.current.sandbox = Sandbox(game.brand);
    mobileFullscreen();
  }
  function mobileExit() {
    mobileBlackScreen.current.setAttribute("style", "display:block");
    mobileMenu.current.setAttribute("style", "display:flex");
  }

  function mobileExitNo() {
    mobileBlackScreen.current.setAttribute("style", "display:none");
    mobileMenu.current.setAttribute("style", "display:none");
  }

  function mobileExitYes() {
    mobileBlackScreen.current.setAttribute("style", "display:none");
    mobileMenu.current.setAttribute("style", "display:none");
    gamePage.current.setAttribute("style", "display:block");
    mobileView.current.setAttribute("style", "display:none");
    mobileIframe.current.src = " ";
    ExitmobileFullscreen();
  }


  function ExitmobileFullscreen() {
    if (document.fullscreenElement) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    } }
  
  function mobileFullscreen() {
    if (document.fullscreenElement) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    } else {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        if (mobileView.current.requestFullscreen) {
          mobileView.current.requestFullscreen({
            navigationUI: "show",
          });
        } else if (mobileView.current.webkitRequestFullscreen) {
          mobileView.current.webkitRequestFullscreen({
            navigationUI: "show",
          });
        } else if (mobileView.current.mozRequestFullScreen) {
          mobileView.current.mozRequestFullScreen({
            navigationUI: "show",
          });
        } else if (mobileView.current.msRequestFullscreen) {
          mobileView.current.msRequestFullscreen({
            navigationUI: "show",
          });
        }

        if (game.orientation == 0) {
          screen.orientation
            .lock("landscape-primary")
            .then(function () {})
            .catch(function (error) {
            });
        } else {
          screen.orientation
            .lock("portrait-primary")
            .then(function () {})
            .catch(function (error) {
            });
        }
      } else {
        if (mobileView.current.requestFullscreen) {
          mobileView.current.requestFullscreen();
        } else if (mobileView.current.webkitRequestFullscreen) {
          mobileView.current.webkitRequestFullscreen();
        } else if (mobileView.current.mozRequestFullScreen) {
          mobileView.current.mozRequestFullScreen();
        } else if (mobileView.current.msRequestFullscreen) {
          mobileView.current.msRequestFullscreen();
        }
      }
    }
  }

  function BreadCatLink(value){
    var link;
    var i;
    var j;
    for(j=0;j<value.length;j++){
    for(i=0;i<Categories.length;i++){
       if(Categories[i].key==value[j]){
         link= Categories[i].path[0];
         i=100; // break the loop
         j=100; // break the loop
        break;
       }
     }

     
    }

   return link;
 }

 function BreadcatName(value){
  var link;
  var i;
  var j;
  for(j=0;j<value.length;j++){
    for(i=0;i<Categories.length;i++){
       if(Categories[i].key==value[j]){
         link= Categories[i].h1;
         i=100; // break the loop
         j=100; // break the loop
         break;
       }
      
     }

     
    }
return link;
}

  // Consistent SERP title: drop legacy "- playcutegames.com" suffix and add a "play free" hook + brand
  const baseTitle = (game.title || game.name[0]).replace(/\s*[-–|]\s*playcutegames(\.com)?\s*$/i, "").trim();
  const seoTitle = baseTitle.length > 40 || /\bplay\b/i.test(baseTitle)
    ? `${baseTitle} | PlayCuteGames`
    : `${baseTitle} - Play Free Online | PlayCuteGames`;

  return (
    <>
      <Headcom
        title={seoTitle}
        s_dis={game.s_dis}
        path={game.path[1] + game.path[0]}
        thumb={game.thumb.startsWith("/") ? game.path[1] + game.thumb : game.thumb}
        logo_16={Assets[0].logo_16}
        logo_32={Assets[0].logo_32}
        logo_192={Assets[0].logo_192}
        logo_270={Assets[0].logo_270}
        logo_512={Assets[0].logo_512}
      />


      {/* JSON-LD Schema for VideoObject */}
      {game.Walkthrough && (
          <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "VideoObject",
            "name": game.name[0],
            "description":game.s_dis,
            "uploadDate": game.date+"T08:00:00+08:00",
            "thumbnailUrl":game.thumb,
            "embedUrl": game.Walkthrough,
            "potentialAction": {
              "@type": "SeekToAction",
              "target": `${game.Walkthrough}?t={seek_to_second_number}`,
              "startOffset-input": "required name=seek_to_second_number"
            }
          })}} />
         )}

      {/* JSON-LD Schema for Product */}
      {game.rating && (
          <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
                "@context": "https://schema.org/",
                "@type": "Product",
                "name": game.name[0],
                "description": game.s_dis,
                "aggregateRating": {
                  "@type": "AggregateRating",
                  "ratingValue":game.rating[0],
                  "bestRating":"5",
                  "reviewCount": game.rating[1],
                },
                // "review": {
                //   "@type": "Review",
                //   "reviewRating": {
                //     "@type": "Rating",
                //     "ratingValue": game.rating[0],
                //     "bestRating": "5",
                //   },
                //   "author": {
                //     "@type": "Person",
                //     "name": "Jentle",
                //   },
                // },
              }),
            }}
          />
      )}

      {/* JSON-LD Schema for Organization */}
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Organization",
              "url": organization.url,
              "logo": organization.logo,
              "image": organization.logo,
              "name": organization.name,
              "description": organization.description,
              "email": organization.email,
              "telephone": organization.telephone,
              "sameAs": organization.sameAs,
              "address": {
                "@type": "PostalAddress",
                "streetAddress": organization.address.streetAddress,
                "addressLocality": organization.address.addressLocality,
                "addressRegion": organization.address.addressRegion,
                "postalCode": organization.address.postalCode,
                "addressCountry": organization.address.addressCountry,
              },
              "vatID": organization.vatID,
              "iso6523Code": organization.iso6523Code,
            }),
          }}
        />

     { game.faq&&<FAQPage faqs={ game.faq}
      />} 


      <div className="app_cont_game">
        <div ref={mobileView} className="mobile-view">
          <div ref={mobileMenu} className="mobile-menu">
            <div className="menu-container">
              <p className="mhead">Quit Game</p>
              <p className="mhead2">Do you Really want to Exit ?</p>
              <div className="yes" onClick={mobileExitYes}>
                <p className="mText">yes</p>
              </div>
              <div className="no" onClick={mobileExitNo}>
                <p className="mText">No</p>
              </div>
            </div>
          </div>
          <div ref={mobileBlackScreen} className="mobile-black_screen"></div>
          <div ref={mobileCanvas} className="mobile-container">
          <MobileExitButton onClick={mobileExit}/>
            <iframe
              ref={mobileIframe}
              title={game.name[0]}
              className="mobile-canvas"
              height="100%"
              width="100%"
              frameBorder="0"
              scrolling="no"
              allowFullScreen
            ></iframe>
          </div>
        </div>
        <div ref={gamePage} className="game-page">
          <BlackScreen />
          <div className="game-root">
            <div className="container">
              <div className="grid-container">
              <GridLayout items={viewMoreUrls} game={game} mOncliock={mPlaybtn} />
                 {/* fixed-height phone ad slots (theme-pink.css) so the ads don't push the page when they load */}
                 <div className="ad-slot-phone-rect">{mobile && <Ad_300x250_1 />}</div>
                 <CategoryGames games={moreGames} title={`Because you played ${game.name[0]}`} />
                 <div className="ad-slot-phone-banner">{mobile && <Ad_320x50 />}</div> 
              </div>
            </div>
          </div>
         
          {!mobile &&  <Ad_728x90_Bot />}
          <div className="container"><PersonalRows mode="game" game={game} /></div>
          <CatBtn />
         
          <CommenDis
            Details={game.Details}
            catlink={catlink}
            cat={catname}
            link={game.path[0]}
            gamename={game.name[0]}
            gamekey={game.tag}
            name={game.name[0]}
            dis={game.l_dis}
            tag={game.tag}
            howto={game.hint}
            video={game.Walkthrough}
            faq={game.faq}
          />
        </div>
      </div>
      <FooterDis />
      <FooterCom />
      <Snow_fx />
      <CookieCom />
    </>
  );
}
